export const CHANGE_PHONE_NUMBER_REQUEST = 'account/CHANGE_PHONE_NUMBER_REQUEST';
export const CHANGE_PHONE_NUMBER_SUCCESS = 'account/CHANGE_PHONE_NUMBER_SUCCESS';
export const CHANGE_PHONE_NUMBER_FAILURE = 'account/CHANGE_PHONE_NUMBER_FAILURE';
export const CHANGE_PHONE_NUMBER_CONFIRM = 'account/CHANGE_PHONE_NUMBER_CONFIRM';
export const CHANGE_PHONE_NUMBER_REJECT = 'account/CHANGE_PHONE_NUMBER_REJECT';

export const changePhoneNumberRequest = ({ mobileNumber }) => ({
  type: CHANGE_PHONE_NUMBER_REQUEST,
  mobileNumber
});
export const changePhoneNumberSuccess = () => ({
  type: CHANGE_PHONE_NUMBER_SUCCESS
});
export const changePhoneNumberFailure = (error) => ({
  type: CHANGE_PHONE_NUMBER_FAILURE,
  error
});
export const changePhoneNumberConfirm = () => ({
  type: CHANGE_PHONE_NUMBER_CONFIRM
});
export const changePhoneNumberReject = () => ({
  type: CHANGE_PHONE_NUMBER_REJECT
});
